// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1H-Ys","range":"MonthRangeSwitch_range__2hfb2","disabled":"MonthRangeSwitch_disabled__1ct19"};